import { UserIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { useCallback, useEffect, useState } from "react";
import { Post } from "types/Post";
import { User } from "types";
import useItem from "common/hooks/useItem";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";
import PageLoading from "../PageLoading/PageLoading";

interface ILikeInfos {
  post: Post;
  thanksDisplayed?: boolean;
}

function LikeInfos({ post, thanksDisplayed }: ILikeInfos) {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);

  const { item, isFetching }: any = useItem("posts", post.id, {
    populate: ["usersThanks", "anonymousThanks"],
  });

  const handleOpenModal = useCallback(() => {
    setShowModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
  }, []);

  useEffect(() => {
    if (!item) return;

    setData(item.usersThanks);
  }, [item]);

  if (isFetching && !item) {
    return <PageLoading />;
  }

  let displayLike;

  if (thanksDisplayed) {
    displayLike = (
      <Button
        icon="HandThumbUpIconSolid"
        title={post?.thanks ? post?.thanks.toString() : "0"}
        type="primary-line"
        onClick={handleOpenModal}
      />
    );
  } else {
    displayLike = (
      <Button
        icon="HandThumbUpIconSolid"
        title={post?.thanks ? post?.thanks.toString() : "0"}
        type="primary-line"
        disabled
      />
    );
  }

  return (
    <>
      {displayLike}
      <Modal visible={showModal} onCloseModal={handleCloseModal}>
        <>
          <h2 className="text-2xl mb-4">{t("thanks.likesTitle")}</h2>
          {data.map((like: User) => (
            <div
              key={like.id}
              className="flex items-center gap-2 mb-2 p-2 rounded-lg hover:bg-slate-50 transition-colors"
            >
              <UserIcon className="w-4 h-4 text-slate-500 flex-shrink-0" />
              <span className="font-bold text-slate-900">
                {like.name || like.username}
              </span>
              <span className="text-sm text-slate-600 font-normal">
                {like.email}
              </span>
            </div>
          ))}
          {item?.anonymousThanks.length > 0 ? (
            <div>
              <p>
                {t("thanks.anonymousLikeTitle", {
                  nbAnonLikes: item?.anonymousThanks.length || 0,
                })}
              </p>
            </div>
          ) : null}
        </>
      </Modal>
    </>
  );
}

export default LikeInfos;
